import { getIsWeb } from "../lib/platformHelper";
import { showModal } from "../lib/react-redux-modal-provider";
import { notifyUnauthorized } from "../lib/auth/unauthorizedHandler";

export const handleApiAccessError = ({
  status,
  response,
  request,
  skipAccessCheck
}) => {
  if (skipAccessCheck) {
    return;
  }

  if (status === 401) {
    if (getIsWeb()) {
      showModal("RegisterModal");
    } else {
      notifyUnauthorized();
    }
    return;
  }

  if (status === 403) {
    let permissions = [];

    try {
      const parsedResponse = JSON.parse(response);

      if (Array.isArray(parsedResponse.permissions)) {
        permissions = parsedResponse.permissions;
      }
    } catch (e) {
      console.error("Failed to parse permissions");
    }

    showModal("PremiumModal", {
      skipShowIfAlreadyVisible: true,
      iframeUrl: request.getResponseHeader("x-popup-url"),
      permissions
    });
  }
};
